import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '../../../common/tooltip';
import Money from '../../../common/money';

const ReportBox = ({ title, amount, count, tooltip }) => (
  <div className="layout__item u-1/1 u-1/7-large-and-up u-text-center">
    <h5 className="c-heading c-heading--dark c-heading--small" display-if={title}>
      {title}
      <Tooltip text={tooltip} display-if={tooltip} />
    </h5>
    <div className="u-font-color-green u-color-grey-lighten-2 u-ph- u-pv-- u-mt-- u-fontsize-small">
      <Money cents={amount} />
    </div>
    <div
      className="u-font-color-green u-color-grey-lighten-2 u-ph- u-pb-- u-mt0 u-fontsize-small"
      display-if={count !== null}
    >
      {count}
    </div>
  </div>
);

ReportBox.propTypes = {
  title: PropTypes.string,
  tooltip: PropTypes.string,
  amount: PropTypes.number,
  count: PropTypes.node,
};

ReportBox.defaultProps = {
  tooltip: null,
  title: null,
  amount: 0,
  count: null,
};

export default ReportBox;
